export default __webpack_public_path__ + "static/media/user-default.feb9adff.jpg";